import { gql } from '@apollo/client';

export const FILTERED_PERSONNEL_POSITIONS = gql`
  query FilteredPersonnelPositions($input: FilterPersonnelPosition!) {
    filteredPersonnelPositions(input: $input) {
      id
      name
    }
  }
`;
